/**
 * reducer
 */

// import { combineReducers } from 'redux'
import { type } from '../../action'

const initState = {
  appShow: false
}
const ebikeData = (state = initState, action) => {
  switch (action.type) {
  case type.SWITCH_MENU:
    return {
      ...state, appShow: action.appShow,
    }
  default:
    return state
  }
}

export default ebikeData